import React, { useState, useEffect } from 'react';
import { Box, Button, IconButton, useMediaQuery, useTheme } from '@mui/material';
import { Link } from 'react-router-dom';
import PhoneIcon from '@mui/icons-material/Phone';
import CloseIcon from '@mui/icons-material/Close';
import { AnimatePresence, motion } from 'framer-motion';

const BRAND_BLUE = '#14a9e8';

export default function StickyCTA() {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const [scrolled, setScrolled] = useState(false);
  const [dismissed, setDismissed] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 400);
    };
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const visible = isMobile && scrolled && !dismissed;

  return (
    <AnimatePresence>
      {visible && (
        <motion.div
          initial={{ y: 100, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: 100, opacity: 0 }}
          transition={{ type: 'spring', stiffness: 300, damping: 30 }}
          style={{
            position: 'fixed',
            bottom: 0,
            left: 0,
            right: 0,
            zIndex: 1200,
          }}
        >
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              gap: 1.5,
              px: 2,
              py: 1.5,
              backgroundColor: 'rgba(11,22,32,0.92)',
              backdropFilter: 'blur(10px)',
              WebkitBackdropFilter: 'blur(10px)',
              position: 'relative',
            }}
          >
            <IconButton
              size="small"
              onClick={() => setDismissed(true)}
              aria-label="Dismiss"
              sx={{
                position: 'absolute',
                top: 4,
                right: 4,
                color: 'rgba(255,255,255,0.6)',
                p: 0.5,
                '&:hover': { color: '#fff' },
              }}
            >
              <CloseIcon sx={{ fontSize: 18 }} />
            </IconButton>

            <Button
              component="a"
              href="tel:+15416061706"
              variant="outlined"
              startIcon={<PhoneIcon />}
              sx={{
                color: '#fff',
                borderColor: 'rgba(255,255,255,0.4)',
                textTransform: 'none',
                fontSize: '0.85rem',
                borderRadius: 2,
                '&:hover': { borderColor: '#fff' },
              }}
            >
              (541) 606-1706
            </Button>

            <Button
              component={Link}
              to="/quote"
              variant="contained"
              sx={{
                backgroundColor: BRAND_BLUE,
                '&:hover': { backgroundColor: '#1291c8' },
                textTransform: 'none',
                fontWeight: 700,
                fontSize: '0.85rem',
                borderRadius: 2,
                px: 3,
              }}
            >
              Free Quote
            </Button>
          </Box>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
